import { createStore } from 'vuex'
import UserSolders from './modules/user-soldiers'

export default createStore({
  modules: {
    UserSolders
  }
})
